import * as React from "react"

export const StrikethroughIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 4C14.7854 4 13.5614 4.27543 12.5 4.79029C11.4386 5.30514 10.5714 6.0432 10 6.94427M4 12H20M8 20C9.21459 20 10.4386 19.7246 11.5 19.2097C12.5614 18.6949 13.4286 17.9568 14 17.0557" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
